import { MonolithLoanApplicant } from '@src/data/types/MonolithLoanApplicant'
import { getApiClient } from '@src/services/api-client'
import { MutationFunction, useMutation } from '@tanstack/react-query'
import axios from 'axios'

async function getMonolithLoanApplicant(loanId: number): Promise<MonolithLoanApplicant | null> {
  try {
    const response = await getApiClient().get<MonolithLoanApplicant>(`/MonolithLoans/${loanId}/Applicant`)
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) return null
    throw error
  }
}

export function useMonolithLoanApplicant(): [MutationFunction<MonolithLoanApplicant | null, number>, boolean] {
  const { mutateAsync, isPending } = useMutation({ mutationFn: getMonolithLoanApplicant })

  return [mutateAsync, isPending]
}
